// TODO: Use native lazyload + intersectionobserver fallback
import LazyLoad from "vanilla-lazyload";

export function init_img_lazyload() {
    // general lazyload instance
    window.lazyLoadInstance = new LazyLoad({
        cancel_on_exit: false,
    });

    // lazyload instances for horizontal scrolll elements
    let elms = document.getElementsByClassName("row-scrollable");
    [].forEach.call(elms, function (el) {
        new LazyLoad({
            container: el,
            cancel_on_exit: false,
        });
    });
}
